import ReportGadgetsContext from '../../../../../../contexts/ReportGadgetsContext';
import { useCallback, useContext } from 'react';
import AccountPickerContext from '../../../../../../contexts/AccountPickerContext';
import getReportGadgetReplacements from './getReportGadgetReplacements';
import updateStoreVisualisation from './updateStoreVisualisation';
import { FindAndReplace } from '../../types';

const useFindAndReplaceChartDefinitions = () => {
  const { allGadgets } = useContext(ReportGadgetsContext);

  const { selectedAccountId } = useContext(AccountPickerContext);

  const replaceChartDefinitions = useCallback(
    async (metricReceipt: FindAndReplace.MetricReceipt) => {
      const { findMetricId, replaceMetricId } = metricReceipt;

      const affectedChartIds =
        metricReceipt.affectedContentIds.chartDefinitions;

      if (!affectedChartIds?.length) {
        return;
      }

      const replacements = getReportGadgetReplacements({
        allGadgets,
        chartDefinitionIds: affectedChartIds,
        findMetricId,
        replaceMetricId,
      });

      await Promise.all(
        replacements.map(({ reportGadgetId, updatedChartDef }) =>
          updateStoreVisualisation({
            accountId: selectedAccountId,
            reportGadgetId,
            updatedChartDef,
          }),
        ),
      );
    },
    [allGadgets, selectedAccountId],
  );

  return replaceChartDefinitions;
};

export default useFindAndReplaceChartDefinitions;
